<label [attr.for]="id" soho-label>{{dimension.label}}</label>
<input
    soho-input
    [attr.id]="id"
    [(ngModel)]="dimension.value"
/>
<button
    soho-button="btn-icon" [icon]="'calendar'"
    id="periodPicker"
    class="lm-compound-field-dialog-button"
    (click)="openPeriodDialog()"
    soho-tooltip [content]="launchButtonTooltip"
></button>
<div #periodPlaceholder id="periodPlaceholder"></div>
